export default "__VITE_ASSET__DCwmqrnL__"